import i18n from '@/i18n';

export type StatType = {
  quantity: number | null;
  label: string;
  icon: string;
};

const getTranslateResult = (key: string) => i18n.t(key) as string;

export const EDITION_MODAL_INFO_TITLE = getTranslateResult(
  'postgradStudyPlanning.configModal.editionTitle',
);
export const BUTTON_TEXT = getTranslateResult('saveStudyPlanning');

export const HOURS_PER_WEEK_STAT: StatType = {
  quantity: null,
  label: getTranslateResult('hoursPerWeek'),
  icon: 'schedule',
};

export const LISTS_PER_WEEK_STAT: StatType = {
  quantity: null,
  label: getTranslateResult('listsPerWeek'),
  icon: 'play',
};

export const TOTAL_WEEKS_STAT: StatType = {
  quantity: null,
  label: getTranslateResult('totalWeeks'),
  icon: 'filledCalendar',
};

export const LAST_DISMISSED_WARNING_MESSAGE_WEEK_ID_KEY = 'lastDismissedWarningMessageWeekId';

export const OVERDUE_STUDENT_IMAGE_URL =
  'https://paperx-dex-assets.s3.sa-east-1.amazonaws.com/images/1635529796337-CoynVl1kAx.png';

export const ANTICIPATE_WEEKLY_LISTS_STUDENT_IMAGE_URL =
  'https://paperx-dex-assets.s3.sa-east-1.amazonaws.com/images/1655302082830-j574vvfmck.png';
